import { UnsubmittedSession } from '@uplift/api';
import { formatUserFullName } from '@uplift/utils';
import { UnsubmittedSessionRow } from './types';

export const convertUnsubmittedSessionsToRows = (unsubmittedSessions: UnsubmittedSession[]): UnsubmittedSessionRow[] => {
  return unsubmittedSessions.map(({ appointment, patient, patientProfile }) => ({
    patientName: formatUserFullName({
      firstName: patient.firstName,
      lastName: patient.lastName,
      preferredFirstName: patientProfile?.preferredName,
    }),
    fromDatetime: appointment.fromDatetime,
    appointmentId: appointment.id,
    appointmentState: appointment.state,
    appointmentType: appointment.type
  }));
};

export const getHasExpiredSession = (unsubmittedSessions: UnsubmittedSession[]): boolean => {
  return unsubmittedSessions.some(row => row.appointment.state === 'expired');
};
